import './App.css';
import Navbar from './components/navbar';
import { BrowserRouter as Router, Route,  Routes } from 'react-router-dom'; 
import Inscrire from './pages/inscrire';
import ComplelerVoterCV from './pages/completer-voter-cv';
import ConsulterCV from './pages/consulter-cv';
import ConsulterCVAdmin from './pages/consulter-cv-pour-admin';
import ConsulterCVPourPostuler from './pages/consulter-voter-cv-pour-postuler';
import Login from './pages/login';
import MesCandidatures from './pages/mes-candidatures';
import ModifierCv from './pages/modifier-cv';
import ModifierExperience from './pages/modifier-experience';
import ModifierFormation from './pages/modifier-formation';
import ModifierPassword from './pages/modifier-password';
import Postuler from './pages/postuler';
import ReinitialiserPassword from './pages/reinitialiser-paasword';
import ResetPassword from './pages/reset-password';
import AdminPage from './pages/rim';
import ValiderInscription from './pages/validerInscription';
import Home from './pages/profile'; 

function App() {

  return (
    <>
      <Router> {/* Enveloppez votre application avec le Router */}
      <>
        <Navbar /> 
        <Routes basename={"/cvtheque-f"}>  
              <Route path="*" element={<Home/>} />
              <Route exact path= {`${process.env.PUBLIC_URL}/profile`} element={<Home />} /> 
              <Route exact path= {`${process.env.PUBLIC_URL}/inscrire`} element={<Inscrire />} />
              <Route exact path= {`${process.env.PUBLIC_URL}/validerInscription/:code`} element={<ValiderInscription />} />
              <Route exact path={`${process.env.PUBLIC_URL}/completer-voter-cv`} element={<ComplelerVoterCV />} />
              <Route exact path={`${process.env.PUBLIC_URL}/consulter-voter-cv`} element={<ConsulterCV />} />
              <Route exact path={`${process.env.PUBLIC_URL}/consulter-cv/:idCV`} element={<ConsulterCVAdmin />} />
              <Route exact path={`${process.env.PUBLIC_URL}/consulter-voter-cv-pour-postuler`} element={<ConsulterCVPourPostuler />} />
              <Route exact path={`${process.env.PUBLIC_URL}/mes-candidatures`} element={<MesCandidatures />} />
              <Route exact path={`${process.env.PUBLIC_URL}/modifier-cv/:id`} element={<ModifierCv />} />
              <Route exact path={`${process.env.PUBLIC_URL}/modifier-experience/:idExperience`} element={<ModifierExperience />} />
              <Route exact path={`${process.env.PUBLIC_URL}/modifier-formation/:idFormation`} element={<ModifierFormation />} />
              <Route exact path={`${process.env.PUBLIC_URL}/modifier-password`} element={<ModifierPassword />} />
              <Route exact path={`${process.env.PUBLIC_URL}/postuler/:idOffre`} element={<Postuler />} />
              <Route exact path={`${process.env.PUBLIC_URL}/reinitialiser-paasword/:token`} element={<ReinitialiserPassword />} />
              <Route exact path={`${process.env.PUBLIC_URL}/reset-password`} element={<ResetPassword />} />
              <Route exact path={`${process.env.PUBLIC_URL}/ll`}  element={<AdminPage />} />
              <Route exact path={`${process.env.PUBLIC_URL}/login`}  element={<Login />} />  
          
        </Routes>
        
      </>
    </Router>

    </>
  );
}

export default App;
